"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNexusObject = void 0;
const nexus_viewer_lib_1 = require("nexus-viewer-lib");
function removeNexusObject(renderer) {
    const nexus = nexus_viewer_lib_1.Nexus.getContext(renderer.getContext());
    nexus.models.forEach((model) => {
        model.nodes.forEach((node) => removeNexusNode(node));
    });
    // nexus.models = [];
    nexus.candidates = [];
}
exports.removeNexusObject = removeNexusObject;
function removeNexusNode(node) {
    // node.patches = [];
    // delete node.texture;
    delete node.indicesBuffer;
    delete node.verticesBuffer;
}
